module.exports = __webpack_public_path__ + "img/vulcans-ff-1.8656131.jpg";